import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { OrganizationStoreService } from '@core/services/entities/organization-store.service';
import { OrganizationStoreResponseDto } from '@domain/organization-store/dtos/organization-store.response.dto';
import { CreateOrganizationStoreRequestDto } from '@domain/organization-store/dtos/create-organization-store.request.dto';
import { ListOrganizationStoreRequestDto } from '@domain/organization-store/dtos/list-organization-store.request.dto';
import { UpdateOrganizationStoreRequestDto } from '@domain/organization-store/dtos/update-organization-store.request.dto';
import { UpdateStateOrganizationStoreRequestDto } from '@domain/organization-store/dtos/update-state-organization-store.request.dto';
import { OrganizationStoreRepository } from '@domain/organization-store/repositories/organization-store.repository';
import { Observable } from 'rxjs';
import { GetOrganizationStoreRequestDto } from '@domain/organization-store/dtos/get-organization-store.request.dto';
import { AssignPersonToOrganizationStoreRequestDto } from '@domain/organization-store/dtos/assign-person-to-organization-store.request.dto';
import { UnassignPersonFromOrganizationStoreRequestDto } from '@domain/organization-store/dtos/unassign-person-from-organization-store.request.dto';
import { GeneratePinOrganizationStoreRequestDto } from '@domain/organization-store/dtos/generate-pin-organization-store.request.dto';
import { UserPersonResponseDto } from '@domain/user-person/dtos/user-person.response.dto';
import { ListAssignedPersonOrganizationStoreRequestDto } from '@domain/organization-store/dtos/list-assigned-person-organization-store.request.dto';
import { AssignCollectorMerchantRequestDto } from '@domain/organization-store/dtos/assign-collector-merchant.request.dto';

@Injectable({
  providedIn: 'root',
})
export class OrganizationStoreRepositoryService
  implements OrganizationStoreRepository
{
  constructor(private organizationStoreService: OrganizationStoreService) {}
  create(
    request: CreateOrganizationStoreRequestDto,
  ): Observable<ApiResponse<OrganizationStoreResponseDto>> {
    return this.organizationStoreService.create(request);
  }
  update(
    request: UpdateOrganizationStoreRequestDto,
  ): Observable<ApiResponse<OrganizationStoreResponseDto>> {
    return this.organizationStoreService.update(request);
  }
  updateState(
    request: UpdateStateOrganizationStoreRequestDto,
  ): Observable<ApiResponse<OrganizationStoreResponseDto>> {
    return this.organizationStoreService.updateState(request);
  }
  generatePin(
    request: GeneratePinOrganizationStoreRequestDto,
  ): Observable<ApiResponse<OrganizationStoreResponseDto>> {
    return this.organizationStoreService.generatePin(request);
  }
  assignPerson(
    request: AssignPersonToOrganizationStoreRequestDto,
  ): Observable<ApiResponse<OrganizationStoreResponseDto>> {
    return this.organizationStoreService.assignPerson(request);
  }
  unassignPerson(
    request: UnassignPersonFromOrganizationStoreRequestDto,
  ): Observable<ApiResponse<OrganizationStoreResponseDto>> {
    return this.organizationStoreService.unassignPerson(request);
  }
  show(request: RefId): Observable<ApiResponse<OrganizationStoreResponseDto>> {
    return this.organizationStoreService.show(request);
  }
  list(
    request: ListOrganizationStoreRequestDto,
  ): Observable<ApiResponse<PageableResponse<OrganizationStoreResponseDto>>> {
    return this.organizationStoreService.list(request);
  }

  get(
    request: GetOrganizationStoreRequestDto,
  ): Observable<ApiResponse<OrganizationStoreResponseDto[]>> {
    return this.organizationStoreService.get(request);
  }

  listAssignedPerson(
    request: ListAssignedPersonOrganizationStoreRequestDto,
  ): Observable<ApiResponse<PageableResponse<UserPersonResponseDto>>> {
    return this.organizationStoreService.listAssignedPerson(request);
  }

  assignCollectorMerchant(
    request: AssignCollectorMerchantRequestDto,
  ): Observable<ApiResponse<void>> {
    return this.organizationStoreService.assignCollectorMerchant(request);
  }
}
